














































































































import { Component, Prop, Watch, Emit } from 'vue-property-decorator'

import { billingType } from '@/modules/Policy/helpers/policy'
import { Quote } from '@/modules/Quote/interfaces/quote'
import { dateTimeToDisplay, dateToDisplay } from '@/utils/dateTime'
import AppDialog from '@/components/AppDialog.vue'
import AppTabs from '@/components/AppTabs.vue'
import AcordFormDialog from '@/components/AcordFormDialog.vue'
import FoldingCard from '@/components/FoldingCard.vue'
import { RecordType } from '@/modules/RecordType/interfaces/record-type'
import { quoteStatus, quoteStatusClass, quoteStatusKeys, quoteStatusValues, quoteTypeKeys, quoteTypeValues } from '@/modules/Quote/helpers/quote'
import { mixins } from 'vue-class-component'
import QuoteDialog from '@/modules/Quote/scripts/quote-dialog'
import { ApolloResponse } from '@/interfaces/apollo'
import { showErrors } from '@/utils/snack'
import { getQuotePremiums, getQuote } from '@/modules/Quote/gql/quote.gql'
import AppSystemInfoCard from '@/components/AppSystemInfoCard.vue'
import QuoteRequestTypeInForm from '@/modules/Quote/components/QuoteRequestTypeInForm.vue'
import QuotePremiumInfo from '@/modules/Quote/components/QuotePremiumInfo.vue'
import QuoteRequestMailForm from '@/modules/Quote/components/QuoteRequestMailForm.vue'
import QuoteRequestTypeDialog from '@/modules/Quote/components/QuoteRequestTypeDialog.vue'
import { QuoteCarrier } from '@/modules/Quote/interfaces/quote-carrier'
import RecordTypesHandler from '@/mixins/record-types'
import { Label } from '@/modules/Label/interfaces/label'
import QuoteDetailRelated from './CaseQuoteDetailRelated.vue'
import QuoteAcordForm from './CaseQuoteAcordForm.vue'

@Component({
  components: {
    FoldingCard,
    AppDialog,
    AppSystemInfoCard,
    QuoteRequestTypeInForm,
    QuotePremiumInfo,
    AcordFormDialog,
    QuoteRequestTypeDialog,
    QuoteRequestMailForm,
    QuoteDetailRelated,
    QuoteAcordForm,
    AppTabs
  }
})
export default class CaseQuoteDrawer extends mixins(QuoteDialog, RecordTypesHandler) {
  @Prop({ type: Number }) readonly quoteId!: number
  @Prop({ type: Object as () => RecordType }) readonly recordType!: RecordType

  dateTimeToDisplay = dateTimeToDisplay
  dateToDisplay = dateToDisplay

  quoteStatus = quoteStatus

  additionalInfoCards: {
    title: string;
    items: {[key: string]: any;}[]
  }[] = []

  quoteAdditional: {
    [key: string]: any;
  } = {}

  requestTypeInForm = {
    show: false,
    step: 0
  }

  quote: Quote | null = null

  quoteCarriers: QuoteCarrier[] = []

  quoteStatusClass = quoteStatusClass
  billingType = billingType

  quoteStatusKeys = quoteStatusKeys
  statusOptions = quoteStatusValues
  quoteTypeKeys = quoteTypeKeys
  typeOptions = quoteTypeValues

  acordFormDialog = {
    show: false
  }

  typeDialog = {
    show: false
  }

  requestMailForm = {
    show: false
  }

  initState = true

  labels: Label[] = []

  quoteLabels: Label[] = []

  tabActive = 0

  tabItems = ['Premium', 'ACORD Form', 'Related']

  folding = false

  get priorTermRoute () {
    if (!this.quote) {
      return null
    }
    return {
      name: 'PolicyDetailDetail',
      params: {
        id: this.quote.priorTerm.id
      }
    }
  }

  get accountRoute () {
    if (!this.quote) {
      return null
    }
    return {
      name: 'AccountDetailDetail',
      params: {
        id: this.quote.account.id
      }
    }
  }

  get contactRoute () {
    if (!this.quote) {
      return null
    }
    return {
      name: 'ContactDetailDetail',
      params: {
        id: this.quote.primaryContact.id
      }
    }
  }

  get carrierRoute () {
    if (!this.quote) {
      return null
    }
    return {
      name: 'CarrierDetailDetail',
      params: {
        id: this.quote.carrier.id
      }
    }
  }

  get carrierProductRoute () {
    if (!this.quote) {
      return null
    }
    return {
      name: 'CarrierProductDetailDetail',
      params: {
        id: this.quote.carrierProduct.id
      }
    }
  }

  get billingTypeOptions () {
    return this.$R.keys(billingType).map((key: string) => {
      return {
        label: billingType[key],
        value: key
      }
    })
  }

  async mounted () {
    if (!this.quoteId) {
      return
    }
    this.getQuote()
  }

  @Watch('quote', { deep: true })
  onQuoteUpdated (val: Quote) {
    this.quoteCarriers = val.premiums
  }

  closingHandler () {
    this.folding = true
    setTimeout(() => {
      this.onClose()
    }, 500)
  }

  @Emit('close')
  onClose () {
    // do nothing
  }

  @Emit('success')
  onSuccess () {
    this.getQuote()
    // do nothing
  }

  handleTabClick (index:number) {
    this.tabActive = index
  }

  showRequestQuoteDialog () {
    this.typeDialog.show = true
  }

  typeSelectedHandler (idx: number) {
    if (idx === 0) {
      this.requestTypeInForm.show = true
    } else {
      this.requestMailForm.show = true
    }
  }

  @Emit('edit')
  editQuote (step: number) {
    return step
  }

  async getQuote () {
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getQuote,
        variables: {
          quoteId: this.quoteId
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.quote = result.data.getQuote as Quote

      const that = this
      this.quoteLabels = JSON.parse(JSON.stringify(this.quote.labels))
      if (this.quoteLabels.length > 0) {
        this.$R.forEach((label: Label) => {
          that.$R.forEach((labelItem: Label) => {
            if (Number(label.id) === Number(labelItem.id)) {
              label.checked = true
            }
          }, that.quoteLabels)
        }, this.labels)
      }

      this.onQuoteUpdated(this.quote)
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async getQuoteCarriers () {
    if (!this.quote) {
      return
    }
    const quoteId = Number(this.quote.id)

    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getQuotePremiums,
        variables: {
          quoteId
        }
      })

      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.quoteCarriers = result.data.getQuotePremiums
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  showAcordFormDialog () {
    this.acordFormDialog.show = true
  }

  hideAcordFormDialog () {
    this.acordFormDialog.show = false
  }
}
